import {Component, OnInit} from '@angular/core';
import {ComponentHelper, FormBaseComponent, ValidatorService} from '@utils-lib';
import {AppNameEnum, Bankverbindung, KontoinhaberEnumLabels} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-bankverbindung',
    templateUrl: './bankverbindung.component.html'
})
export class BankverbindungComponent extends FormBaseComponent<Bankverbindung> implements OnInit {

    public kontoinhaberEnum = KontoinhaberEnumLabels;
    public kontoinhaberOptions;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                private readonly translateService: TranslateService,
                protected readonly messageService: DatevMessageService,
                protected readonly activatedRoute: ActivatedRoute) {
        super(messageService);
    }

    private static isInlaendischeIban(iban: string): boolean {
        return iban?.toLocaleUpperCase().startsWith('DE');
    }

    public ngOnInit(): void {
        super.ngOnInit();

        this.kontoinhaberOptions = [];
        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);

        if (appEnum === AppNameEnum.FragebogenKapG ||
            appEnum === AppNameEnum.FragebogenKapGAus || appEnum === AppNameEnum.FragebogenPersG) {
            this.kontoinhaberOptions.push({
                value: KontoinhaberEnumLabels._1, label: `COMMON_UI.BANKVERBINDUNG.KONTOINHABER.KAPG.KEY_${KontoinhaberEnumLabels._1}`
            });
            this.kontoinhaberOptions.push({
                value: KontoinhaberEnumLabels._99, label: `COMMON_UI.BANKVERBINDUNG.KONTOINHABER.KAPG.KEY_${KontoinhaberEnumLabels._99}`
            });
        } else {
            // default values
            this.kontoinhaberOptions.push({
                value: KontoinhaberEnumLabels._1, label: `COMMON_UI.BANKVERBINDUNG.KONTOINHABER.KEY_${KontoinhaberEnumLabels._1}`
            });
            this.kontoinhaberOptions.push({
                value: KontoinhaberEnumLabels._2, label: `COMMON_UI.BANKVERBINDUNG.KONTOINHABER.KEY_${KontoinhaberEnumLabels._2}`
            });
            this.kontoinhaberOptions.push({
                value: KontoinhaberEnumLabels._3, label: `COMMON_UI.BANKVERBINDUNG.KONTOINHABER.KEY_${KontoinhaberEnumLabels._3}`
            });
            this.kontoinhaberOptions.push({
                value: KontoinhaberEnumLabels._99, label: `COMMON_UI.BANKVERBINDUNG.KONTOINHABER.KEY_${KontoinhaberEnumLabels._99}`
            });
        }
    }

    public isAuslaendischeIban(): boolean {
        return this.data.iban?.length > 1 && !BankverbindungComponent.isInlaendischeIban(this.data.iban);
    }

    public onKontoinhaberChanged(): void {
        if (this.data.kontoinhaber === null) {
            this.data.bic = null;
            this.form.get('bic').setValue(null);
            this.data.bezeichnung = null;
        }
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            kontoinhaber: [this.data.kontoinhaber, []],
            abweichenderKontoinhaber: [
                this.data.abweichenderKontoinhaber,
                [
                    this.validatorService.conditionalValidator(() =>
                        this.data.kontoinhaber === KontoinhaberEnumLabels._99,
                        this.validatorService.required()),
                    this.validatorService.minLength(1),
                    this.validatorService.maxLength(128)
                ]],
            iban: [this.data.iban,
                [
                    this.validatorService.required(),
                    this.validatorService.conditionalValidator(() => BankverbindungComponent.isInlaendischeIban(this.data.iban),
                        this.validatorService.pattern('^DE[0-9]{3,20}$',
                            this.translateService.instant('COMMON_UI.VALIDATION.IBAN_INVALID_PATTERN'))),
                    this.validatorService.conditionalValidator(() => this.isAuslaendischeIban(),
                        this.validatorService.pattern('^([a-zA-Z]{2})[0-9]{2}[0-9a-zA-Z]{1,30}$',
                            this.translateService.instant('COMMON_UI.VALIDATION.IBAN_INVALID_PATTERN')))
                ]],
            bic: [this.data.bic,
                [
                    this.validatorService.conditionalValidator(() => this.isBicRequired(),
                        this.validatorService.required()),
                    this.validatorService.pattern('^[a-zA-Z]{4}([a-zA-Z]{2})[0-9a-zA-Z]{2}([0-9a-zA-Z]{3})?$',
                        this.translateService.instant('COMMON_UI.VALIDATION.BIC_INVALID_PATTERN'))
                ]]
        });
    }

    private isBicRequired(): boolean {
        if (this.data.iban?.toLocaleUpperCase().startsWith('CH')) {
            return true;
        } else if (this.data.iban?.toLocaleUpperCase().startsWith('SM')) {
            return true;
        } else if (this.data.iban?.toLocaleUpperCase().startsWith('MC')) {
            return true;
        } else {
            return false;
        }
    }

}
